// import forge from 'node-forge';

// const encryptKeyPem = `-----BEGIN PUBLIC KEY-----
// ${process.env.REACT_APP_ENCRYPT_KEY}
// -----END PUBLIC KEY-----`;
// const decryptKeyPem = `-----BEGIN RSA PRIVATE KEY-----
// ${process.env.REACT_APP_DECRYPT_KEY}
// -----END RSA PRIVATE KEY-----`;

// export const encryptData = function (data) {
//   const publicKey = forge.pki.publicKeyFromPem(encryptKeyPem);
//   const encrypted = publicKey.encrypt(forge.util.encodeUtf8(JSON.stringify(data)), 'RSA-OAEP');
//   return forge.util.encode64(encrypted);
// }

// export function decryptData(encryptedBase64) {
//   const privateKey = forge.pki.privateKeyFromPem(decryptKeyPem);
//   const encrypted = forge.util.decode64(encryptedBase64);
//   const decrypted = privateKey.decrypt(encrypted, 'RSA-OAEP');
//   return JSON.parse(forge.util.decodeUtf8(decrypted));
// }

import forge from "node-forge";

const encryptKeyPem = `-----BEGIN PUBLIC KEY-----
${process.env.REACT_APP_ENCRYPT_KEY}
-----END PUBLIC KEY-----`;

const decryptKeyPem = `-----BEGIN RSA PRIVATE KEY-----
${process.env.REACT_APP_DECRYPT_KEY}
-----END RSA PRIVATE KEY-----`;

export const encryptData = function (data) {
  try {
    // ✅ Handle undefined / null
    if (data === undefined || data === null) {
      data = null;
    }

    // ✅ Safe stringify (important for undefined case)
    const jsonData = JSON.stringify(data);

    if (!jsonData) return null;

    const publicKey = forge.pki.publicKeyFromPem(encryptKeyPem);

    const encrypted = publicKey.encrypt(
      forge.util.encodeUtf8(jsonData),
      "RSA-OAEP",
    );

    return forge.util.encode64(encrypted);
  } catch (error) {
    console.error("Encryption Error:", error);
    return null;
  }
};

export function decryptData(encryptedBase64) {
  try {
    // ✅ Handle empty input
    if (!encryptedBase64 || typeof encryptedBase64 !== "string") {
      return null;
    }

    const privateKey = forge.pki.privateKeyFromPem(decryptKeyPem);

    const encrypted = forge.util.decode64(encryptedBase64);

    const decrypted = privateKey.decrypt(encrypted, "RSA-OAEP");

    const decoded = forge.util.decodeUtf8(decrypted);

    // ✅ Handle empty decrypted value
    if (!decoded) return null;

    // ✅ Safe JSON parse
    try {
      return JSON.parse(decoded);
    } catch (e) {
      console.warn("Invalid JSON after decrypt");
      return decoded; // fallback
    }
  } catch (error) {
    console.error("Decryption Error:", error);
    return null;
  }
}
